module.exports = __webpack_public_path__ + "img/send_succ.ec7bc1b4.svg";